import React, { useEffect, useState } from "react"
import { GetApi } from "../../../../api/api"
import Dropdown from "react-bootstrap/Dropdown"
import { useHistory, useParams } from "react-router-dom"
import useQuery from "../UseQuery"

export interface ILanguage {
  code: string
  name: string
}

const LanguageSelector = () => {
  const [languages, setLanguages] = useState(new Array<ILanguage>())
  const { catalog } = useParams<{ catalog: string; type: string; pid: string }>()
  const history = useHistory()
  const query = useQuery()

  useEffect(() => {
    const getLanguages = async () => {
      GetApi().then((api) => {
        api.getAnyFeatureCatalogLanguages(catalog).then(async (response) => {
          const result = new Array<any>()
          response.map((language) => {
            result.push({
              code: language.code,
              name: language.DisplayName
            })
          })
          setLanguages(result)
        })
      })
    }
    getLanguages()
  }, [])
  const currentLanguageCode = query.get("language")

  const onSelect = (eventKey: any, event: object) => {
    const searchParams = new URLSearchParams(history.location.search)
    searchParams.set("language", eventKey)
    history.replace({pathname: history.location.pathname, state: history.location.state, search: "?" + searchParams})
  }

  const selectedLanguage =
    currentLanguageCode && languages
      ? languages.find((l) => l.code?.toLowerCase() === currentLanguageCode.toLowerCase())
      : undefined
  
  return languages && languages.length > 0 ? (
    <Dropdown onSelect={onSelect}>
      <Dropdown.Toggle variant="outline-primary" id="dropdown-basic" className="w-100">
        {selectedLanguage === undefined ? "Select Language" : selectedLanguage.name}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {languages.map((language) => {
          return (
            <Dropdown.Item
              key={"lng:" + language.code}
              eventKey={language.code}
              active={language.code === currentLanguageCode}
            >
              {language.name}
            </Dropdown.Item>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <></>
  )

}

export default LanguageSelector
